"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EObjectType = void 0;
let EObjectType = /*#__PURE__*/function (EObjectType) {
  EObjectType["HOUSE"] = "houseSale";
  EObjectType["TOWNHOUSE"] = "townhouseSale";
  EObjectType["LAND"] = "landSale";
  EObjectType["COTTAGE"] = "cottageSale";
  EObjectType["HOUSE_SHARE"] = "houseShareSale";
  return EObjectType;
}({});
exports.EObjectType = EObjectType;